

























































































































































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {namespace,Mutation} from 'vuex-class';
import {Mall} from 'supporter';
import {addMonth} from '@/utils/dateUtils';
import { resetLoadingCount } from '@/api';
import moment from 'moment';
import MallStatusBar from './MallStatusBar.vue';
const mallModule = namespace('mall');
@Component({
  components: {
    MallStatusBar
  }
})
export default class TopMain extends Vue {
  @Mutation('SET_DIMMEDAREASWITCH') private setDimmedAreaSwitch!: (flag: boolean) => void;
  @Mutation('SET_DIMMEDAREA') private setDimmedArea!: (flag: boolean) => void;
  @Prop({required: true}) private mainMall!: any;
  @mallModule.State('malls') private stateMalls!: Mall[];
  private sale_summary_guide = false;
  private delay_summary_guide = false;
  private orderOptionSaleSummary:any = {
    deliveryPrepare: '-',
    productPrepare: '-',
    depositWait: '-',
    holdDelivery: '-',
    deliveryDone: '-',
    newOrder: '-',
    deliveryIng: '-'
  };
  private claimsSummaryDelay:any = {
    cancelDelayCount: '-',
    returnDelayCount: '-',
    exchangeDelayCount: '-'
  };
  private productInquiriesDelayedCount:string|number = '-';
  private delaySummary:string|number = '-';
  private delayHoldSummary:string|number = '-';
  private claimsSummary:any = {
    returnRequestCount: '-',
    exchangeRequestCount: '-',
    cancelRequestCount: '-'
  };
  private productSummary: any = {
    APPROVAL_READY: '-',
    AFTER_APPROVAL_READY: '-',
    ON_SALE: '-',
    SOLD_OUT: '-',
    DEADLINE_SEVEN_DAYS: '-',
    STOCK_UNDER_TEN: '-'
  };
  private readonly saleSummaryParams = {
    startYmd: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    endYmd: moment().format('YYYY-MM-DD'),
  }
  private readonly delaySummaryParams = {
    startYmd: moment().subtract(3, 'months').format('YYYY-MM-DD'),
    endYmd: moment().format('YYYY-MM-DD'),
    delay: 'true',
  }
  private readonly claimSummaryParams = {
    startYmd: moment().subtract(3, 'months').format('YYYY-MM-DD'),
    endYmd: moment().format('YYYY-MM-DD'),
  }

  private readonly deliveryHoldDelayEndYmd = moment().subtract(3, 'days').format('YYYY-MM-DD');

  private readonly readyForScreeningParams = {
    applyStatusTypes: ['APPROVAL_READY']
  };
  private readonly readyForScreeningAfterApprovalParams = {
    applyStatusTypes: ['AFTER_APPROVAL_READY']
  };
  private readonly onSaleParams = {
    saleStatus: {
      types: [
        'ON_SALE'
      ]
    }
  };
  private readonly soldoutParams = {
    stockRange: {
      maxStockCnt: 0
    }
  };
  private readonly sevenSalesDaysParams = {
    remainsSaleDays: 7
  };
  private readonly maxStockCount10Params = {
    stockRange: {
      maxStockCnt: 10
    }
  };

  private convertQueryObject(queryObject: Record<string,string>):string {
    return new URLSearchParams(queryObject).toString();
  }

  mounted() {
    this.search();
  }
  @Watch('mainMall.no')
  onMainMallNoChanged() {
    this.search();
  }
  getMallNos(): string {
    let mallNos = '';
    if (this.mainMall.no) {
      mallNos = '' + this.mainMall.no;
    } else {
      mallNos = this.stateMalls.map((mall) => mall.mallNo).toString();
    }
    return mallNos;
  }
  getSalesSummary(mallNos: string) {
    const getOrderOptionsSaleSummaryMallParams = {
      mallNos
    }
    // 판매현황 조회
    this.$api.getOrderOptionsSaleSummaryMall({params: getOrderOptionsSaleSummaryMallParams}).then((ret) => {
      this.orderOptionSaleSummary = ret.data;
    });
  }
  getDelaySummary(mallNos: string) {
    const getClaimsSummaryDelayParams = {
      mallNos,
      period: '3',
      unit: 'MONTH'
    };
    // 처리현황:취소지연, 반품지연, 교환 지연
    this.$api.getClaimsSummaryDelay({params: getClaimsSummaryDelayParams}).then((ret) => {
      this.claimsSummaryDelay = ret.data;
    });
    const delaySummaryRequest = {
      params: {
        mallNos,
        orderStatusTypes: 'PRODUCT_PREPARE'
      }
    };

    // 처리현황:발송지연
    this.$api.getOrderOptionsMallDelaySummary(delaySummaryRequest).then((res) => {
      this.delaySummary = res.data.delayCount;
    });
    const getOrderOptionsDeliveryHoldSummary = {
      mallNos
    };
    // 처리현황:발송지연
    this.$api.getOrderOptionsDeliveryHoldSummary({params: getOrderOptionsDeliveryHoldSummary}).then((res) => {
      this.delayHoldSummary = res.data.delayedCount;
    });
    // 처리현황:답변지연
    if (this.mainMall.no) {
      this.$api.getProductInquiriesDelayedCount({params: {mallNo: this.mainMall.no}}).then((res) => {
        this.productInquiriesDelayedCount = res.data;
      });
    } else {
      this.$api.getProductInquiriesDelayedCount().then((res) => {
        this.productInquiriesDelayedCount = res.data;
      });
    }
  }
  getClaimsSummary(mallNos: string) {
    const getClaimsSummaryParams = {
      mallNos,
      period: '3',
      unit: 'MONTH'
    };
    // 클레임현황
    return this.$api.getClaimsSummary({params: getClaimsSummaryParams}).then((ret) => {
      this.claimsSummary = ret.data;
    });
  }
  getProductSummary(mallNos: string) {
    // 상품현황

    const searchTypeList = ['APPROVAL_READY', 'AFTER_APPROVAL_READY', 'ON_SALE', 'SOLD_OUT', 'DEADLINE_SEVEN_DAYS', 'STOCK_UNDER_TEN'];
    const startYmd = addMonth(new Date(), -3, '-');
    searchTypeList.forEach((type) => {
      const getProductsSummariesBySearchTypeParams: any = {
        pathParams: {
          searchType: type
        },
        params: {
          startYmd
        }
      };
      if (this.mainMall.no) {
        getProductsSummariesBySearchTypeParams.params.mallNo = mallNos;
      }
      this.$api.getProductsSummariesBySearchType(getProductsSummariesBySearchTypeParams).then((ret) => {
        this.productSummary[ret.data.searchType] = ret.data.count;
      });
    });
  }
  search() {
    const mallNos = this.getMallNos();
    this.setDimmedAreaSwitch(true);
    this.getSalesSummary(mallNos);
    this.getDelaySummary(mallNos);
    this.getClaimsSummary(mallNos);
    this.getProductSummary(mallNos);
  }
  open(url: string) {
    window.open(url, '_blank');
  }

  async handleClaimsSummaryRefreshButton() {
    this.setDimmedArea(true);
    await this.getClaimsSummary(this.getMallNos());
    this.setDimmedArea(false);
  }

  beforeDestroy() {
    resetLoadingCount();
  }
}
